import { Button } from "@mui/material";
import * as React from "react";
import { useLanguage } from "../../Language";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useTitleNavigation } from "../../nav/TitleNavigationProvider";
import { Link } from "react-router-dom";

export const BackToLink = () => {
  const { backToLink } = useTitleNavigation();
  const { href, label } = backToLink || {};
  const { translate } = useLanguage();

  return (
    <>
      {backToLink && (
        <Button
          component={Link}
          to={href}
          startIcon={<KeyboardBackspaceIcon />}
        >
          {translate("backTo")} {translate(label)}
        </Button>
      )}
    </>
  );
};
